export const state = {
  isLoading: false,
  isSaving: false,
  dictionary: [],
  card: {},
  cards: [],
  changes: {},
  expert: false,
  compared: [],
  comparedData: [],
  notifications: [],
  isFileLoading: false,
  isFileSaving: false,
  user: {
    username: "",
    message: "",
    // tokens: "",
    role: "",
  },
};
